import React, { useEffect, useRef } from 'react'
import { ChevronIcon } from './icons'

// Reusable dropdown trigger button with an attached panel.
// - Renders the trigger label + chevron; aria-expanded drives the open style.
// - Handles outside-click + Escape to close (delegates to onClose).
// - Wraps the panel in an absolutely-positioned container anchored to the trigger.
//
// DEV-2980: drawn as the storefront's filter dropdown (.fb-dd + .fb-menu,
// styled by www/storefront_chrome.css). `multi` is the wide facet panel
// (Category / Charity / Cause); without it, the narrow sort menu. A trigger
// with selections reads "Category (2)" and goes bold, as on the storefront.

export default function FilterTrigger({ label, count = 0, isOpen, onToggle, onClose, children, alignRight, multi }) {
  const wrapperRef = useRef(null)

  useEffect(() => {
    if (!isOpen) return undefined

    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        onClose()
      }
    }
    function handleEsc(e) {
      if (e.key === 'Escape') onClose()
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEsc)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEsc)
    }
  }, [isOpen, onClose])

  const menuClass = ['fb-menu', multi ? 'fb-menu-multi' : '', alignRight ? 'fb-menu-right' : ''].filter(Boolean).join(' ')

  return (
    <div className="fb-dd-wrap" ref={wrapperRef}>
      <button
        type="button"
        className={'fb-dd' + (count > 0 ? ' is-active' : '')}
        aria-haspopup={multi ? 'dialog' : 'menu'}
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span>{count > 0 ? `${label} (${count})` : label}</span>
        <ChevronIcon />
      </button>
      {isOpen && <div className={menuClass} role={multi ? 'dialog' : 'menu'}>{children}</div>}
    </div>
  )
}
